import styled from 'styled-components'

interface EditorContainerProps {
  $borderRadius?: string
  $toolbarRound?: string
  $minHeight?: string
}

export const EditorContainer = styled.div<EditorContainerProps>`
  overflow: visible;
  position: relative;
  z-index: 0;

  &:focus-within {
    z-index: 30;
  }

  .quill {
    border: 1px solid #999999;
    border-radius: ${({ $borderRadius }) => $borderRadius || '15px'};
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 100%;
    overflow: visible;
    position: relative;

    .ql-toolbar {
      background-color: #eeeeee;
      border: 0;
      display: flex;
      /* overflow: auto; */
      flex-wrap: wrap;
      column-gap: 6px;
      overflow: visible;
      position: relative;
      z-index: 2;
      border-top-left-radius: ${({ $borderRadius }) => $borderRadius || '15px'};
      border-top-right-radius: ${({ $borderRadius }) => $borderRadius || '15px'};
      &::after {
        display: none;
      }
      .ql-formats {
        margin-right: 0px;
        column-gap: 0.6em;
        display: inline-flex;
        vertical-align: middle;
      }
      .ql-picker-options {
        z-index: 40;
      }
      .ql-picker.ql-expanded .ql-picker-options {
        display: block;
      }
      .ql-color-picker.ql-expanded .ql-picker-options,
      .ql-icon-picker.ql-expanded .ql-picker-options {
        z-index: 40;
      }
      .ql-formats:has(.ql-redo) {
        margin-left: auto;
        display: flex;
        column-gap: 1em;
        &::after {
          display: none;
        }
      }

      .ql-undo,
      .ql-redo {
        position: relative;
        background: none;
        border: none;
        cursor: pointer;
        display: flex;
        justify-self: end;
        align-items: center;
        justify-content: center;
        width: 24px;
      }

      .ql-link {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        cursor: pointer; /* Hide the existing link icon */
        svg {
          display: none;
        } /* Add the new link icon */
        &::before {
          content: '';
          position: absolute;
          width: 24px;
          height: 24px;
          background-size: contain;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" className ="bg-red-200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 17H7C5.67392 17 4.40215 16.4732 3.46447 15.5355C2.52678 14.5979 2 13.3261 2 12C2 10.6739 2.52678 9.40215 3.46447 8.46447C4.40215 7.52678 5.67392 7 7 7H11V9H7C6.20435 9 5.44129 9.31607 4.87868 9.87868C4.31607 10.4413 4 11.2044 4 12C4 12.7956 4.31607 13.5587 4.87868 14.1213C5.44129 14.6839 6.20435 15 7 15H11V17ZM17 7H13V9H17C17.7956 9 18.5587 9.31607 19.1213 9.87868C19.6839 10.4413 20 11.2044 20 12C20 12.7956 19.6839 13.5587 19.1213 14.1213C18.5587 14.6839 17.7956 15 17 15H13V17H17C18.3261 17 19.5979 16.4732 20.5355 15.5355C21.4732 14.5979 22 13.3261 22 12C22 10.6739 21.4732 9.40215 20.5355 8.46447C19.5979 7.52678 18.3261 7 17 7ZM16 11H8V13H16V11Z" fill="black"/></svg>');
        }
      }
      .ql-action {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        cursor: pointer; /* Hide the existing link icon */
        svg {
          display: none;
        } /* Add the new link icon */
        &::before {
          content: '';
          position: absolute;
          width: 14px;
          height: 14px;
          background-size: contain;
          background-repeat: no-repeat;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml;utf8,<svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 12C3.5 12.8 2.8 13.5 2 13.5C1.2 13.5 0.5 12.8 0.5 12C0.5 11.2 1.2 10.5 2 10.5C2.8 10.5 3.5 11.2 3.5 12ZM3.5 7C3.5 7.8 2.8 8.5 2 8.5C1.2 8.5 0.5 7.8 0.5 7C0.5 6.2 1.2 5.5 2 5.5C2.8 5.5 3.5 6.2 3.5 7ZM3.5 2C3.5 2.8 2.8 3.5 2 3.5C1.2 3.5 0.5 2.8 0.5 2C0.5 1.2 1.2 0.5 2 0.5C2.8 0.5 3.5 1.2 3.5 2Z" fill="black"/></svg>');
        }
      }
    }

    .ql-container {
      min-height: ${({ $minHeight }) => $minHeight || '80px'};
      border: 0;
      flex: 1;
      overflow: visible;
    }
  }
`
